import Bootstrap from '$js/bootstrap';
import BaseModule from '$js/app/base/BaseModule';
import { MarqueeFooterPartners } from '$js/modules/footer-partners/marquee-footer-partners';
import { Preload } from '$js/modules/misc/preload';
import { CalculateColumnWidth } from '$src/js/modules/content/wrapper-col-width';
import { ThemeSwitchRender } from '$src/js/modules/misc/theme-switch';
import { AddToHomescreen } from '$src/js/modules/add-to-homescreen/initAddToHomescreen';

new CalculateColumnWidth();
new Bootstrap();
new MarqueeFooterPartners();
new Preload();
new ThemeSwitchRender();
new AddToHomescreen();

if (window.breaking_bar) {
  import('./isolated/BreakingbarService')
    .then(({ BreakingBarService }) => {
      new BreakingBarService().validate();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (document.querySelector('.js-partner-cards') && window.partner_cards) {
  import('./modules/partner-cards/partner-cards')
    .then(({ PartnerCardsClass }) => {
      new PartnerCardsClass();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (document.querySelector('.js-podcasts')) {
  import('./modules/content-items/podcasts')
    .then(({ PodcastsClass }) => {
      new PodcastsClass();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (document.querySelector('.js-now-reading')) {
  import('./modules/content-items/now-reading')
    .then(({ NowReadingClass }) => {
      new NowReadingClass();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (document.querySelector('.js-image-slider')) {
  import('./modules/imageslider/imageslider')
    .then(({ ImageSliderClass }) => {
      new ImageSliderClass();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (window.creator_profile) {
  import('./modules/creator/profile')
    .then(({ CreatorProfile }) => {
      new CreatorProfile();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (window.rider_data) {
  BaseModule.getInstance().ads.setAdsToAsync();

  import('./modules/rider/profile')
    .then(({ RiderProfile }) => {
      new RiderProfile();

      BaseModule.getInstance().ads.initializeAds();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (window.cycling_team_data) {
  BaseModule.getInstance().ads.setAdsToAsync();

  import('./modules/team/profile')
    .then(({ TeamProfile }) => {
      new TeamProfile();

      BaseModule.getInstance().ads.initializeAds();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (document.querySelector('.js-team-overview-table')) {
  BaseModule.getInstance().ads.setAdsToAsync();

  import('./modules/tables/team-overview-table')
    .then(({ TeamOverviewTable }) => {
      new TeamOverviewTable();

      BaseModule.getInstance().ads.initializeAds();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (document.querySelector('.js-trending-riders')) {
  import('./modules/rider/trending')
    .then(({ TrendingRiders }) => {
      new TrendingRiders();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (window.race_calendar_minimized) {
  if (document.querySelector('.js-minimized-calendar')) {
    import('./modules/races/minimal/calendar')
      .then(({ MinimalCalendarBlock }) => {
        new MinimalCalendarBlock();
      })
      .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
  }

  if (document.querySelector('.js-minimized-latest-results')) {
    import('./modules/races/minimal/latest-results')
      .then(({ MinimalLatestResultsBlock }) => {
        new MinimalLatestResultsBlock();
      })
      .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
  }
}

if (document.querySelector('.js-now-racing')) {
  import('./modules/races/minimal/now-racing')
    .then(({ NowRacingBlock }) => {
      new NowRacingBlock();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (document.querySelector('.js-content-team-tabs')) {
  BaseModule.getInstance().ads.setAdsToAsync();

  import('./modules/team/content-tabs')
    .then(({ ContentTeamTabsClass }) => {
      new ContentTeamTabsClass();

      BaseModule.getInstance().ads.initializeAds();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (document.querySelector('.js-content-rider-tabs')) {
  BaseModule.getInstance().ads.setAdsToAsync();

  import('./modules/rider/content-tabs')
    .then(({ ContentRiderTabsClass }) => {
      new ContentRiderTabsClass();

      BaseModule.getInstance().ads.initializeAds();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (document.querySelector('.js-rider-overview-table')) {
  BaseModule.getInstance().ads.setAdsToAsync();

  import('./modules/tables/rider-overview-table')
    .then(({ RiderOverviewTable }) => {
      new RiderOverviewTable();

      BaseModule.getInstance().ads.initializeAds();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (document.querySelector('.js-race-calendar')) {
  BaseModule.getInstance().ads.setAdsToAsync();

  import('./modules/tables/calendar-table')
    .then(({ CalendarTable }) => {
      new CalendarTable();

      BaseModule.getInstance().ads.initializeAds();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (document.querySelector('.js-embed')) {
  import('./modules/content/embeds')
    .then(({ EmbedsClass }) => {
      new EmbedsClass();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (document.querySelector('.js-creator-overview')) {
  BaseModule.getInstance().ads.setAdsToAsync();

  import('./modules/creator/overview')
    .then(({ CreatorOverviewLoader }) => {
      new CreatorOverviewLoader();

      BaseModule.getInstance().ads.initializeAds();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (document.querySelector('.js-cycling-edition-tabs')) {
  BaseModule.getInstance().ads.setAdsToAsync();

  import('./modules/races/edition')
    .then(({ EditionDetailLoader }) => {
      new EditionDetailLoader();

      BaseModule.getInstance().ads.initializeAds();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (document.querySelector('.js-cycling-stage-tabs')) {
  BaseModule.getInstance().ads.setAdsToAsync();

  import('./modules/races/stage')
    .then(({ StagesLoader }) => {
      new StagesLoader();

      BaseModule.getInstance().ads.initializeAds();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (document.querySelector('.js-race-event-profile')) {
  BaseModule.getInstance().ads.setAdsToAsync();

  import('./modules/races/event')
    .then(({ EventLoader }) => {
      new EventLoader();

      BaseModule.getInstance().ads.initializeAds();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (document.querySelector('.js-scrollbooster')) {
  import('./modules/content/scrollbooster')
    .then(({ scrollBooster }) => {
      new scrollBooster();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (document.querySelector('.js-race-result')) {
  import('./modules/content/race-results')
    .then(({ RaceResultsInContentClass }) => {
      new RaceResultsInContentClass();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (document.querySelector('.js-race-startlist')) {
  import('./modules/content/race-startlist')
    .then(({ RaceStartListInContentClass }) => {
      new RaceStartListInContentClass();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (document.querySelector('.js-liveblog, .js-liveblog-page')) {
  import('./modules/liveblog/LiveblogModule')
    .then(({ LiveblogModule }) => {
      new LiveblogModule().renderPage();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (document.querySelector('.js-liveblog-overview-page')) {
  import('./modules/liveblog/LiveblogModule')
    .then(({ LiveblogModule }) => {
      new LiveblogModule().renderOverviewPage();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (window.embed_popup) {
  import('./modules/embed-popup/init')
    .then(({ EmbedPopupModule }) => {
      new EmbedPopupModule().render();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (document.querySelector('.js-skoda-race-radio-popup')) {
  import('./modules/skoda-race-radio/init')
    .then(({ SkodaRaceRadioModule }) => {
      new SkodaRaceRadioModule().renderRadioPopup();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

// No async ads? Load them here :)
BaseModule.getInstance().ads.fallbackAdLoad();
